import { render, staticRenderFns } from "./ApplicationRating.vue?vue&type=template&id=379afee4&"
import script from "./ApplicationRating.vue?vue&type=script&lang=js&"
export * from "./ApplicationRating.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationRating.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports